/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { ProtectedRouter } from 'infrastructure/routing';
import { Route, createRoute } from 'framework/routing';
import { CREATE_SERVICE, READ_SERVICE, READ_SERVICES_LIST, SERVICE_PATH, UPDATE_SERVICE } from 'domain/shared/service';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import ServiceList from 'domain/organization/service/List';
import ViewService from 'domain/organization/service/Show';
import ServiceContext from 'domain/organization/service/ServiceContext';
import CreateService from 'domain/organization/service/createupdate/Create';
import UpdateService from 'domain/organization/service/createupdate/Update';

const useServiceRoute = () => {
  return createRoute({ listRoute: SERVICE_PATH });
};

const ServiceRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute, createRoute: createServiceRoute, updateRoute } = useServiceRoute();

  return (
    <ProtectedRouter basePath={SERVICE_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_SERVICES_LIST}>
              <ServiceList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createServiceRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_SERVICE}>
              <CreateService />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <ServiceContext permissionToCheck={READ_SERVICE}>
              <ViewService />
            </ServiceContext>
          }
        />

        <Route
          path={updateRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={UPDATE_SERVICE}>
              <UpdateService />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ServiceRouter.getRouterPath = () => `${SERVICE_PATH}/*`;

export default ServiceRouter;
